import React from "react";

const Footer: React.FC = () => {
  return (
    <div className="FooterContainer">
      <div style={{ textAlign: "justify" }}>
        <br />
        Bristol Myers Squibb ou son prestataire en charge de l'information par
        démarchage ou prospection visant à la promotion du médicament s'engagent
        à respecter la Charte de l'information par démarchage ou prospection
        visant à la promotion du médicament et le référentiel de certification
        en vigueur. Nos délégués médicaux ou les délégués médicaux de notre
        prestataire, ainsi que leurs accompagnants s'engagent à suivre les
        règles de déontologie de Bristol Myers Squibb, et se tiennent à votre
        disposition pour vous les présenter et répondre à vos éventuelles
        questions.&nbsp;<br></br>
        <br></br>Afin d'interagir avec vous, Bristol Myers Squibb, agissant en
        tant que responsable de traitement, est amené à traiter des données
        personnelles vous concernant. Ce traitement se justifie par l'intérêt
        légitime de Bristol Myers Squibb et le cas échéant, par le respect de
        ses obligations légales. Vous disposez, à tout moment et dans certaines
        conditions, d'un droit d'accès à vos données personnelles ainsi que le
        droit de vous les faire communiquer d'un droit d'opposition et de
        limitation du traitement, et de demander à ce que vos données soient
        rectifiées, complétées et/ou effacées. Si vous souhaitez exercer l'un de
        vos droits, veuillez contacter le Délégué à la Protection des Données de
        Bristol Myers Squibb à l'adresse suivante :{" "}
        <a
          href="mailto:EUDPO@BMS.com"
          target="_blank"
          rel="noopener noreferrer"
          className="couleurLien"
        >
          EUDPO@BMS.com.
        </a>{" "}
        <br></br> <br></br>Bristol Myers Squibb, veuillez contacter le service
        Information Médicale par téléphone au 01 58 83 84 96, par télécopie au
        +33 (0)1 58 83 66 98 ou par courriel à l'adresse suivante :
        infomed@bms.com Vous pouvez également déclarer les effets indésirables
        directement via le portail de signalement des événements sanitaires
        indésirables du Ministère chargé de la santé :
        <a
          href="https://signalement.social-sante.gouv.fr/"
          target="_blank"
          rel="noopener noreferrer"
          className="couleurLien"
        >
          https://signalement.social-sante.gouv.fr/
        </a>{" "}
        &nbsp;<br></br> <br></br>
      </div>
    </div>
  );
};

export default Footer;
